export const FILTER_BACKGROUND = {
    NESCAFE: "nescafe",
}